// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nTPK7WAqh7AovYly0snw"};